import { StyledDownloadButton } from './DownloadButton.styled';

const DownloadButton = ({ children, onClick, disabled = false }) => {
  return (
    <StyledDownloadButton $disabled={disabled} onClick={() => disabled ? true : onClick()}>
      {children}
      <div className='download-button-corner-icon'>
        <img src='/assets/download.svg' />
      </div>
    </StyledDownloadButton>
  );
};

export default DownloadButton;
